import { Editor } from '@tunasong/plugin-lib'
import type { TunaEditor } from '@tunasong/plugin-lib'

/**
 * A failed send puts the text back only into an empty box, so it never overwrites what was typed meanwhile. The chat
 * reads the same rule to say whether the text came back (GH #2453).
 */
export const isComposerEmpty = (editor: TunaEditor) => Editor.string(editor, []) === ''
